import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import { __assign, __awaiter, __generator } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: function state() {
    return {
      apply: {
        id: 0,
        user_id: 0,
        name: '',
        district_level: [],
        leader: '',
        mobile: '',
        start_date: '',
        mailing_address_list: [],
        mailing_address: '',
        description: '',
        image: [],
        is_lock: false
      }
    };
  },
  mutations: {
    /**
     * 记录申请
     * @param {} apply 申请数据
     */
    setApply: function setApply(state, apply) {
      state.apply = apply;
    }
  },
  actions: {
    /**
     * 获得战队申请信息
     * @param {} forceUpdate
     */
    getIdentificationApply: function getIdentificationApply(_a, forceUpdate) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, data;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/running_group')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;

                if (data) {
                  data.district_level = [data.district_level_1, data.district_level_2, data.district_level_3].filter(function (_) {
                    return _;
                  });
                  delete data.district_level_1;
                  delete data.district_level_2;
                  delete data.district_level_3;
                  data.mailing_address_list = [data.mailing_address_1, data.mailing_address_2, data.mailing_address_3].filter(function (_) {
                    return _;
                  });
                  delete data.mailing_address_1;
                  delete data.mailing_address_2;
                  delete data.mailing_address_3;
                  data.image = data.image || [];
                  commit('setApply', data);
                }
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 申请创建战队
     * @param {} data 数据
     */
    updateApply: function updateApply(_a) {
      var state = _a.state,
          commit = _a.commit,
          dispatch = _a.dispatch;
      return __awaiter(this, void 0, void 0, function () {
        var apply, response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              apply = state.apply;
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/running_group', __assign(__assign({}, apply), {
                district_level_1: apply.district_level[0],
                district_level_2: apply.district_level[1],
                district_level_3: apply.district_level[2],
                mailing_address_1: apply.mailing_address_list[0],
                mailing_address_2: apply.mailing_address_list[1],
                mailing_address_3: apply.mailing_address_list[2],
                image_key: apply.image.map(function (image) {
                  return image.key;
                })
              }))];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;